import { createFileRoute } from '@tanstack/react-router';
import { UserDetailPage } from '@/features/preparer/users/UserDetailPage';

export const Route = createFileRoute('/preparer/users/$userId')({
  component: UserDetailPage,
});
